var map = {
	"./2.svg": 2624,
	"./AISGcert.pdf": 2588,
	"./ASTAR.jpg": 6175,
	"./AWSskillcert.pdf": 1430,
	"./DiplomaP2024.pdf": 2980,
	"./Director231.pdf": 9936,
	"./Director232.pdf": 743,
	"./Director241.pdf": 6353,
	"./OH1.jpeg": 237,
	"./Tropy Star.png": 8536,
	"./about.png": 401,
	"./arrow1.svg": 8550,
	"./arrow2.svg": 4773,
	"./banner-bg.png": 9368,
	"./beleaf1.jpeg": 8699,
	"./beleaf2.jpeg": 4782,
	"./beleaf3.jpeg": 6741,
	"./beleaf4.jpeg": 5376,
	"./book.png": 563,
	"./book2.png": 5913,
	"./botany1.jpeg": 3379,
	"./botany2.jpeg": 7254,
	"./botany3.jpeg": 5517,
	"./brain.pdf": 4042,
	"./brain2.jpg": 5102,
	"./brain2.pdf": 3324,
	"./career1.jpeg": 3670,
	"./career2.jpeg": 6147,
	"./career3.jpeg": 2060,
	"./cert.png": 4066,
	"./color-sharp.png": 4468,
	"./color-sharp2.png": 4972,
	"./comp.jpeg": 3042,
	"./contact-img.png": 8968,
	"./designGA1.jpeg": 9486,
	"./disney.png": 7928,
	"./disney1.png": 5459,
	"./disney2.png": 9704,
	"./disney3.png": 833,
	"./ecofy.png": 5646,
	"./focus.png": 2050,
	"./focus2.png": 2298,
	"./focus3.png": 1155,
	"./focuscrew1.png": 5856,
	"./geek.png": 8540,
	"./geekout.jpeg": 2631,
	"./github.png": 1165,
	"./hackstart.jpeg": 8128,
	"./huawei.jpeg": 2228,
	"./immersive1.png": 3978,
	"./immersive2.png": 2961,
	"./immersive3.png": 8344,
	"./internship.jpg": 1050,
	"./journal2.png": 9857,
	"./journal3.png": 2376,
	"./journal4.png": 1367,
	"./journalapp.png": 8514,
	"./kkhchatbot.jpg": 5815,
	"./logo.png": 5549,
	"./meter1.svg": 7298,
	"./meter2.svg": 8049,
	"./meter3.svg": 16,
	"./mypic.png": 6288,
	"./name.pdf": 1247,
	"./nav-icon1.svg": 710,
	"./nav-icon2.svg": 8933,
	"./nav-icon3.svg": 6324,
	"./ntu.JPG": 1702,
	"./othersact.png": 8569,
	"./pcep.png": 56,
	"./pcepcert.pdf": 7372,
	"./portfolio.png": 5210,
	"./resume.pdf": 7139,
	"./scamateur.png": 2603,
	"./sitemap.png": 1795,
	"./sticker.png": 1551,
	"./sticker1.png": 3078,
	"./sticker2.png": 109,
	"./sticker3.png": 7604,
	"./sticker4.png": 7547,
	"./style.png": 2985,
	"./style2.png": 8111,
	"./travel2.png": 7408,
	"./travelapp.png": 971,
	"./ui1.png": 9521,
	"./ui2.png": 3274,
	"./ui3.png": 3107,
	"./ui4.png": 60,
	"./ui5.png": 1685,
	"./vr1.jpeg": 9452,
	"./world1.jpeg": 486,
	"./yfc.jpeg": 2471,
	"./yfc2.jpeg": 8855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;